'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@common/components/molecule/Accordion';
import { useSuspenseQuery } from '@tanstack/react-query';
import Image from 'next/image';
import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useAuthStore } from '@/stores/AuthStore';
import WandImage from './event-reward-wand.png';
const ACCORDION_VALUE = 'event-reward';
interface EventRewardCardProps {
  productNumber: string;
  defaultExpanded?: boolean;
  className?: string;
}
export const eventRewardQueryOptions = ({
  productNumber,
  entry,
  isLogin
}: {
  productNumber: string;
  entry: ReturnType<typeof useWebviewTypeEntry>['entry'];
  isLogin: boolean;
}) => {
  const queryOptions = isLogin ? AuthQueryOptions['get:/wello/v2/auth/home-donation-event/reward'] : UnauthQueryOptions['get:/wello/v2/allows/home-donation-event/reward'];
  return queryOptions({
    query: {
      productNumber,
      entry
    }
  });
};
export const EventRewardCard = props => {
  const $ = _c(4);
  const {
    entry,
    isEntryResolved
  } = useWebviewTypeEntry();
  const isLogin = useAuthStore(_temp);
  if (!isEntryResolved || isLogin === undefined) {
    return null;
  }
  let t0;
  if ($[0] !== entry || $[1] !== isLogin || $[2] !== props) {
    t0 = <EventRewardCardContent {...props} entry={entry} isLogin={isLogin} />;
    $[0] = entry;
    $[1] = isLogin;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
const EventRewardCardContent = t0 => {
  const $ = _c(27);
  const {
    productNumber,
    defaultExpanded: t1,
    className,
    entry,
    isLogin
  } = t0;
  const defaultExpanded = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== entry || $[1] !== isLogin || $[2] !== productNumber) {
    t2 = eventRewardQueryOptions({
      productNumber,
      entry,
      isLogin
    });
    $[0] = entry;
    $[1] = isLogin;
    $[2] = productNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      ...t2,
      select: _temp2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data
  } = useSuspenseQuery(t3);
  let t4;
  if ($[6] !== data?.contents) {
    t4 = data?.contents ?? [];
    $[6] = data?.contents;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const rewards = t4;
  if (rewards.length === 0) {
    return null;
  }
  let t5;
  if ($[8] !== defaultExpanded) {
    t5 = defaultExpanded ? [ACCORDION_VALUE] : [];
    $[8] = defaultExpanded;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src={WandImage} alt="" width={20} height={20} className="size-20 shrink-0 object-contain" />;
    t7 = <span className="flex-1 font-600 text-Gray-800 typo-body4">내가 받을 수 있는 혜택</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  const t8 = data?.totalRewardAmount ?? 0;
  let t9;
  if ($[12] !== t8) {
    t9 = t8.toLocaleString("ko-KR");
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <Accordion.Trigger ellipsis={true} title={<span className="flex w-full items-center gap-4">{t6}{t7}<span className="font-600 text-Gray-black typo-body4">{t9}원+</span></span>} className="gap-4 p-16" />;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== rewards) {
    t11 = rewards.map(_temp3);
    $[16] = rewards;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <Accordion.Content className="px-16 pb-16 pt-0"><ul className="flex flex-col gap-12 rounded-small bg-Gray-25 p-12">{t11}</ul></Accordion.Content>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <Accordion.Item value={ACCORDION_VALUE} className="rounded-medium border border-B-300 bg-Gray-white">{t10}{t12}</Accordion.Item>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== className || $[24] !== t13 || $[25] !== t5) {
    t14 = <Accordion variant="separated" defaultValues={t5} className={className}>{t13}</Accordion>;
    $[23] = className;
    $[24] = t13;
    $[25] = t5;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
const RewardAmount = t0 => {
  const $ = _c(14);
  const {
    point,
    naverPay
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== naverPay || $[1] !== point) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const reward = point ? {
        label: "\uC6F0\uD3EC\uC778\uD2B8",
        amount: point
      } : naverPay ? {
        label: "\uB124\uC774\uBC84\uD398\uC774",
        amount: naverPay
      } : undefined;
      if (!reward) {
        t5 = null;
        break bb0;
      }
      t3 = "flex shrink-0 items-center gap-4 whitespace-nowrap text-Gray-800 typo-caption1";
      t4 = <span className="font-400">{reward.label}</span>;
      t1 = "font-600";
      t2 = reward.amount.toLocaleString("ko-KR");
    }
    $[0] = naverPay;
    $[1] = point;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t2) {
    t6 = <span className={t1}>{t2}원</span>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <span className={t3}>{t4}{t6}</span>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp3(t0) {
  const {
    eventName,
    point,
    naverPay
  } = t0;
  return <li key={eventName} className="flex items-start justify-between gap-8"><span className="min-w-0 flex-1 break-words font-400 text-Gray-600 typo-caption1">{eventName}</span><RewardAmount point={point} naverPay={naverPay} /></li>;
}